






























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import {
  ClaimType,
  LinkedExpense
} from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import Button from "@/shared/components/ui/Button.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { formatCurrency } from "@/shared/currency";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useClaimStore } from "@/employee/store/claim";

@Component({
  components: {
    Pill,
    Button,
    CurrencyAmount,
    GenericLoadingSpinner
  },
})
export default class LinkedExpenseRow extends Vue {
  claimStore = useClaimStore();

  @Prop() linkedExpense: LinkedExpense;

  @Prop() index: number;

  ClaimType = ClaimType;
  moment = moment;
  formatCurrency = formatCurrency;
  noteIsVisible = false;

  get isReimbursed (): boolean {
    return this.linkedExpense.expense.reimbursedAmount
        && this.linkedExpense.expense.reimbursedAmount > 0;
  }

  removeLink (expenseId: number) {
    this.claimStore.removeClaimToExpenseLink({
      claimNumber: this.linkedExpense.claimNumber,
      expenseId
    });
  }

  isAltRow (rowId: number): boolean {
    return rowId % 2 === 0;
  }

  toggleNoteVisible () {
    this.noteIsVisible = !this.noteIsVisible;
  }
}
